/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeModel } from '../../models/employee-model';

export interface GetAttorneys$Json$Params {
}

export function getAttorneys$Json(http: HttpClient, rootUrl: string, params?: GetAttorneys$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeModel>>> {
  const rb = new RequestBuilder(rootUrl, getAttorneys$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeModel>>;
    })
  );
}

getAttorneys$Json.PATH = '/api/Attorney';
